import React, { useState, useEffect, useMemo, useRef } from 'react';
import {
  Container,
  FormGroup,
  Label,
  Input,
  Button,
  Row,
  Col,
  Modal,
  ModalHeader,
  ModalBody,
  InputGroup, InputGroupAddon, InputGroupText
} from 'reactstrap';
import { connect } from 'react-redux';
import { IRecuRecreation, IClientEditRedux, ITarget, IAuthReduxProps } from '../../types/interfaces';

import TableContainer from "../tables_manager/TableContainer"
import EditableCell from "../tables_manager/EditableCell";
import Select from 'react-select';
import CreatableSelect from 'react-select/creatable';
import { createPlaceholderDrive, replaceRecu } from '../../flux/actions/venteActions';
import { addRecuReq } from '../../flux/actions/recureqActions';
import { getConstanteProjetInfos, getConstanteRecuImageIncrem } from '../../flux/actions/constanteActions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrash, faExternalLinkAlt, faPen, faSpinner, faPencilRuler, faCheckCircle, faHourglassHalf } from '@fortawesome/free-solid-svg-icons'
import axios from 'axios';
import { E_ERROR } from '../../types/errors';
import { useAlert } from "react-alert";
import moment from "moment";
import { instantUploadToFTP } from '../pdf/PDFLink';
import { getEncModeRegl } from '../../services/misc';
import { PRIVILEGE } from '../../types/privileges'

const RecuRecreation = ({
  modal,
  setModal,
  modalData,
  savedCallback,
  addRecuReq,
  auth
 }: IRecuRecreation) => {
  const typeOptions = [{value: "R", label: "Reçu de Réservation"}, {value: "S", label: "Avances Supplémentaires"}]
  const [selectedType, setSelectedType] = useState<any>('');
  const [recu, setRecu] = useState<any>(undefined);
  const [isNewRecu, setIsNewRecu] = useState<boolean>(false);
  const [vente, setVente] = useState<any>(undefined);
  const [isAssociation, setIsAssociation] = useState<boolean>(false);
  const [associationId, setAssociationId] = useState<any>(undefined);
  const [clients, setClients] = useState<any[]>([]);
  const [selectedClients, setSelectedClients] = useState<any[]>([]);
  const [encaissements, setEncaissements] = useState<any[]>([]);
  const [selectedEncaissements, setSelectedEncaissements] = useState<any[]>([]);
  const [disableSubmit, setDisableSubmit] = useState(false);
  const [reEnable, setReEnable] = useState(false);

  const alert = useAlert();
  
  const handleToggle = () => setModal(!modal);
  
  const handleTypeChange = e => setSelectedType(e || '')

  const modalOpenedHandle = () => {
    if(modalData && modalData !== ''){
      setRecu(modalData.isNewRecu ? undefined : modalData.recu);
      setIsNewRecu(modalData.isNewRecu);
      setVente(modalData.vente);
      const recuId = modalData.isNewRecu ? undefined : modalData.recu.id
      const isAssociation = modalData.isNewRecu ? modalData.isAssociation : modalData.recu.association === 1
      const associationId = modalData.isNewRecu ? modalData.associationId : modalData.recu.association_id
      const enc_supp = modalData.isNewRecu ? false : modalData.recu.enc_supp === 1
      const clientsTemp = modalData.vente.contrat_clients.filter(e => !isAssociation || Number(e.ID_ASS) === associationId)
      const encaissementsTemp = modalData.vente.contrat_encaissements.filter(e => !isAssociation || Number(e.ID_ASS) === associationId)
      setIsAssociation(isAssociation);
      setAssociationId(associationId);
      setClients(clientsTemp);
      setSelectedClients(clientsTemp.map(e => e.id));
      setEncaissements(encaissementsTemp);
      setSelectedEncaissements(encaissementsTemp.filter(e => !enc_supp || e.supp_recu_id === recuId).map(e => e.id));
      setSelectedType(typeOptions.find(e => e.value === (enc_supp ? "S" : "R")) || '');
    }
  };

  const modalClosedHandle = () => {
    setRecu(undefined);
    setIsNewRecu(false);
    setVente(undefined);
    setIsAssociation(false);
    setAssociationId(undefined);
    setClients([]);
    setSelectedClients([]);
    setEncaissements([]);
    setSelectedEncaissements([]);
    setSelectedType('');
    if(reEnable){
      setDisableSubmit(false);
      setReEnable(false);
    }
  };

  const confirmHandle = async () => {
    if(!vente || (!recu && !isNewRecu))
      return
    if(!selectedType)
      return
    setDisableSubmit(true);
    const constantesProjet = await getConstanteProjetInfos(vente.IDPROJET || -1, vente.PROJET || "");
    const recu_image_counter = isNewRecu ? await getConstanteRecuImageIncrem() : recu.recu_image_counter

    const placeholderData = await createPlaceholderDrive(isNewRecu ? undefined : recu.id, isNewRecu ? 1 : 0, recu_image_counter, selectedType.value, vente.id, vente.ID_BIEN, isAssociation ? 1 : 0, associationId, 1, 0, auth?.user?.id)
    if(!placeholderData?.fileId || !placeholderData?.webViewLink){
      alert.error("No placeholder")
      setDisableSubmit(false)
      return
    }
    const recuFile: any = await instantUploadToFTP({
      documentType: "recu",
      data: {...vente, enc: selectedType?.value === "S", contrat_clients: (vente.contrat_clients || []).filter(e => selectedClients.includes(e.id)), addedContratEnc: (vente.contrat_encaissements || []).filter(e => selectedEncaissements.includes(e.id)).map(e => ({...e.encaissement, ...e})), contrat_encaissements: (vente.contrat_encaissements || []).filter(e => selectedEncaissements.includes(e.id)), recu_image_counter/*, isNewAssociation: recu.association === 1*/, associationId: associationId, constantesProjet, webViewLink: placeholderData.webViewLink, authUserId: auth?.user?.id},
      // data: {...vente, enc: recu.enc_supp === 1/*, addedContratClients: table_clients*/, contrat_clients: (vente.contrat_clients || []).filter(t => recu.association !== 1 || Number(t.ID_ASS) === recu.association_id), addedContratEnc: (vente.contrat_encaissements || []).filter(t => recu.association !== 1 || Number(t.ID_ASS) === recu.association_id).filter(t => recu.enc_supp !== 1 || t.supp_recu_id === recu.id).map(e => ({...e.encaissement, ...e})), recu_image_counter: recu.recu_image_counter/*, isNewAssociation: recu.association === 1*/, associationId: recu.association_id, constantesProjet, authUserId: auth?.user?.id},
      showPreviewWatermark: false,
    });
    // const recuId = isNewRecu ? placeholderData.recuId : recu.id
    replaceRecu(isNewRecu ? placeholderData.recuId : recu.id, /*isNewRecu ? 1 : */0, recu_image_counter, selectedType.value, vente.id, vente.ID_BIEN, isAssociation ? 1 : 0, associationId, selectedClients, selectedEncaissements, recuFile, placeholderData.fileId, placeholderData.webViewLink, auth?.user?.id).then(e => {
      if(e.file){
        savedCallback(e)
        setReEnable(true);
        setModal(false);
        alert.success("Reçu généré et sauvegardé avec succès");
      }
      else
        alert.error("Une erreur s'est produite")
    })
    .catch(() => alert.error("Une erreur s'est produite"))
    .finally(() => setDisableSubmit(false))
  };

  const confirmReqHandle = async () => {
    if(!vente || (!recu && !isNewRecu))
      return
    if(!selectedType){
      alert.error("Veuillez sélectionner le type du reçu");
      return
    }
    setDisableSubmit(true);
    addRecuReq(selectedClients, selectedEncaissements, vente.id, associationId, isAssociation ? 1 : 0, selectedType?.value === "S" ? 1 : 0, isNewRecu ? undefined : recu.id, callbackReq)
  };

  const callbackReq = (success) => {
    if(success && !success.err){
      setReEnable(true);
      setModal(false);
      alert.success("Demande envoyée avec succès");
      return
    }
    if(success?.err?.alreadyExists)
      alert.error("Demande déjà envoyée");
    else
      alert.error("Une erreur s'est produite");
    setDisableSubmit(false);
  }

  return (
    <div>
      <Modal isOpen={modal} toggle={handleToggle} onOpened={modalOpenedHandle} onClosed={modalClosedHandle}>
        <ModalHeader toggle={handleToggle}><FontAwesomeIcon icon={faPencilRuler} />&nbsp;&nbsp;Regénération du reçu de vente</ModalHeader>
        <ModalBody>
            <Container className="linesConfirmationContainer">
              <Row>
                {isNewRecu ? <Col xs="12">Voulez-vous vraiment créer un nouveau reçu?</Col> : <Col xs="12">Voulez-vous vraiment recréer le reçu <b>{recu?.id}</b>?</Col>}
              </Row>
              <Row>
                <Col xs="12">
                  <FormGroup>
                    {/* <Label for="type">Situation familiale</Label> */}
                    <Select
                      id="type"
                      className="reactselect"
                      classNamePrefix="react-select"
                      defaultValue={typeOptions[0]}
                      value={selectedType}
                      onChange={handleTypeChange}
                      placeholder={'Type...'}
                      isClearable={false}
                      loadingMessage={() => 'Chargement...'}
                      noOptionsMessage={() => 'pas de resultat'}
                      isSearchable={false}
                      options={typeOptions}
                    />
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col xs="12">Clients ({selectedClients.length}/{clients.length})</Col>
              </Row>
              <div className="selectableList">
                {clients.map((e, key) => <div className="selectableListItem text-center" style={{background: "none", ...(selectedClients.includes(e.id) ? {backgroundColor: "#62af42"} : {})}} onClick={() => setSelectedClients(t => t.includes(e.id) ? t.filter(n => n !== e.id) : [...t, e.id])} key={key}>
                  <div className="selectableListContent"><div className="selectableListContentDiv">{e.client?.NOM || "-"} {e.client?.PRENOM || ""}</div></div>
                </div>)}
              </div>
              <Row>
                <Col xs="12">Encaissements ({selectedEncaissements.length}/{encaissements.length})</Col>
              </Row>
              <div className="selectableList">
                {encaissements.map((e, key) => <div className="selectableListItem text-center" style={{background: "none", ...(e.encaissement?.notValid == 1 ? {color: "darkred"} : {}), ...(selectedEncaissements.includes(e.id) ? {backgroundColor: "#62af42"} : {})}} onClick={() => (e.encaissement?.notValid != 1) && setSelectedEncaissements(t => t.includes(e.id) ? t.filter(n => n !== e.id) : [...t, e.id])} key={key}>
                  <div className="selectableListContent"><div className="selectableListContentDiv"><b>Réf. Règlement:</b>&nbsp;{e.encaissement?.REF_REGLEMENT || "-"}&nbsp;&nbsp;&nbsp;<b>Part</b>&nbsp;{(e.PART || 0).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} DH</div></div>
                  <div className="cardSticker selectableListFloatingTitle" title={getEncModeRegl(e.encaissement?.MODE_REGL)}>{getEncModeRegl(e.encaissement?.MODE_REGL)}</div>
                </div>)}
              </div>
              <Row className="justify-content-center">
                {!!auth?.user?.privileges?.includes(PRIVILEGE.VENTE_NORMALE) && <Button
                  className="btn btn-info linesConfirmationBtn linesDeleteBtn"
                  onClick={confirmReqHandle}
                  disabled={disableSubmit}
                  ><FontAwesomeIcon icon={disableSubmit ? faSpinner : faHourglassHalf} className={disableSubmit ? "spinner" : ""} />&nbsp;&nbsp;Envoyer une demande</Button>}
                {!!auth?.user?.privileges?.includes(PRIVILEGE.WEBMASTER) && <Button
                  className="btn btn-success linesConfirmationBtn linesDeleteBtn"
                  onClick={confirmHandle}
                  disabled={disableSubmit}
                  ><FontAwesomeIcon icon={disableSubmit ? faSpinner : faCheckCircle} className={disableSubmit ? "spinner" : ""} />&nbsp;&nbsp;Générer un reçu de vente</Button>}
              </Row>
            </Container>
        </ModalBody>
      </Modal>
    </div>
  );
};

const mapStateToProps = (state: IAuthReduxProps) => ({
  auth: state.auth,
  error: state.error,
});

export default connect(mapStateToProps, { addRecuReq })(RecuRecreation);
